export enum TypeAssociatedProd {
    BUYABLE='buyable',
    ANNOUNCE='announce',
    NOT_APPLICABLE='notApplicable'
}